/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://5rljbvwqj7.execute-api.us-east-2.amazonaws.com/hyattmakka",
            "region": "us-east-2"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://hyvucistsne6jlvxofqiqe7na4.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-xdm3rodoszhrtfyqjlxiq7posq",
    "aws_cognito_identity_pool_id": "us-east-2:f2944c5e-f11f-4e23-9c15-4d273bdc8611",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_Kk6QsjhuR",
    "aws_user_pools_web_client_id": "4n95hvvhakanqu45obnscqkm5a",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL",
        "PHONE_NUMBER"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
